import { forwardRef } from 'react';

export const ComboBoxInput = forwardRef(({ id, value, placeholder, disabled, isOpen, onOpen, onChange, label, isClearable, selectedValue, onClear, required }, ref) => {
    const handleFocus = () => {
        if (!isOpen) onOpen();
    };

    const handleClick = () => {
        if (!isOpen) onOpen();
    };

    const handleChange = (e) => {
        onChange(e.target.value);
    };

    const handleClearClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onClear?.();
    };

    const hasValue = Array.isArray(selectedValue) ? selectedValue.length > 0 : selectedValue != null;
    const showClearButton = isClearable && hasValue && !disabled;

    return (
        <div className={`form-control${required ? ' required' : ''}`}>
            <label htmlFor={id} className="control-label">
                {label}
            </label>
            <div className="skynet-combobox-input-wrapper">
                <input
                    ref={ref}
                    id={id}
                    type="text"
                    className="form-control rounded-8 skynet-form-input"
                    value={value}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onClick={handleClick}
                    autoComplete="off"
                    role="combobox"
                    aria-expanded={isOpen}
                    aria-autocomplete="list"
                    aria-controls={`${id}-listbox`}
                />

                {showClearButton && (
                    <span
                        className="skynet-combobox-clear vismaicon vismaicon-dynamic vismaicon-close vismaicon-sm"
                        onClick={handleClearClick}
                        role="button"
                        tabIndex="0"
                        aria-label="Clear selection"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleClearClick(e);
                            }
                        }}
                    />
                )}
                <span className={`skynet-combobox-caret caret${disabled ? ' disabled' : ''}${isOpen ? ' skynet-combobox-caret-up' : ''}`} aria-hidden="true" />
            </div>
        </div>
    );
});
